export default "__VITE_ASSET__BKUh3r_e__"